import * as Cookies from 'tiny-cookie'
import * as UAParser from 'ua-parser-js'
import $config from '@/config'
import router from '../../router'

let checkSecurity = async (context, userParams)=>{
  let pageSettings = context.rootGetters['page-settings/getCopy'];
  let device = context.rootGetters['devices/getCopy'];;
  /*
  webcastId: null,
  eventPasswordEnabled: false,
  eventPassword: '',
  ipWhiteListEnabled: false,
  ipWhiteList: '',
  emailDomainWhiteListEnabled: false,
  emailDomainWhiteList: '',
  referrerDomainWhiteListEnabled: false,
  referrerDomainWhiteList: '',
  */

  if(pageSettings.ipWhiteListEnabled){
    if(device){
      let ipArray = pageSettings.ipWhiteList.split(',')
      if(!_.includes(ipArray, device.ip)){
        router.push('/403');
        return false;
      }
    }
  }

  if(pageSettings.emailDomainWhiteListEnabled){
    if(_.has(userParams, 'info.email')){
      let domainArray = pageSettings.emailDomainWhiteList.split(',')
      let userDomain = userParams.info.email.replace(/.*@/, "");
      if(!_.includes(domainArray, userDomain)){
        router.push('/403');
        return false;
      }
    }
  }

  return true;
}

export default {
  keepCopiesInStore: true,
  actions: {
    async initUser(context, params){
      let initType = null;

      await checkSecurity(context, params).then((res)=>{
        //console.log("security resolved");
        if(res===false){
          params = null;
          return null;
        }
      });

      if(Cookies.get(params.webcastId)){
        initType = "cookie"
      } else if(!params.isAnonymous){
        initType = "registration"
      }

      switch (initType){
        case "cookie":
          return this.dispatch('registrations/get', Cookies.get(params.webcastId)).then((userList)=>{
            context.commit("setCurrent", userList.data[0]);
            return userList.data[0];
          }).catch((error) => {
            console.log(error)
          })
          break;
        case "registration":
          /* Check user from store */
          params['device'] = context.rootGetters['devices/getCopy'];
          if(!params.uid){
            params['uid'] = params.info.uid
            params['name'] = params.info.name
            params['location'] = params.info.location
          }
          return this.dispatch('registrations/create', params ).then((user)=>{
            Cookies.set(params.webcastId, user._id);
            context.commit("setCurrent", user._id);
            return user;
          });
          break;
      }
    },

    logout(context, webcastId){
      Cookies.remove(webcastId);
      context.commit("clearCurrent");
      return;
    }
  }
}
